import { render, staticRenderFns } from "./jpointRecommend.vue?vue&type=template&id=d9ab5b1a&scoped=true"
import script from "./jpointRecommend.vue?vue&type=script&lang=js"
export * from "./jpointRecommend.vue?vue&type=script&lang=js"
import style0 from "./jpointRecommend.vue?vue&type=style&index=0&id=d9ab5b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ab5b1a",
  null
  
)

export default component.exports